// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__5dC6G","location":"Header_location__2M6K5"};